import { mapGetters } from 'vuex'

export default {
  ...mapGetters('signUp', {
    steps: ['getSignUpApplicationSteps']
  }),
  firstName () {
    return this.steps.agreement.firstName || 'N/A'
  },
  address1 () {
    return this.steps.agreement.address1 || 'N/A'
  },
  lastName () {
    return this.steps.agreement.lastName || 'N/A'
  },
  address2 () {
    return this.steps.agreement.address2 || 'N/A'
  },
  email () {
    return this.steps.agreement.email || 'N/A'
  },
  city () {
    return this.steps.agreement.city || 'N/A'
  },
  phone () {
    return this.steps.agreement.phone || 'N/A'
  },
  stateName () {
    return this.steps.agreement?.state?.name || 'N/A'
  },
  signed () {
    return this.steps.agreement.firstName + ' ' + this.steps.agreement.lastName || 'N/A'
  },
  title () {
    return this.steps.agreement.yourTitle || 'N/A'
  },
  zipCode () {
    return this.steps.agreement.zipCode || 'N/A'
  },
  countryName () {
    return this.steps.agreement.country?.name || 'N/A'
  },
  foundryDescription () {
    return this.steps.foundry.foundryDescription || 'N/A'
  },
  foundryName () {
    return this.steps.foundry.foundryName || 'N/A'
  },
  designers () {
    return this.steps.designers.designers || []
  },
  existingDesigners () {
    return this.steps.existingDesigners || []
  },
  designerValues () {
    return {
      values: this.steps.existingDesigners.length
        ? this.steps.existingDesigners.map(
          (item) => ({ edit: item.name, label: item.name, value: item.id })
        )
        : []
    }
  }
}
